import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import configData from "../../config/config.json";
import BackButton from "../common/BackButton";
import Alert from "../common/modal/Alert";
import Loading from "../common/modal/Loading";
import { LOADING_STATUES } from "../constants/constants";

export default function ForgotUsernameSmall() {
  const history = useHistory();
  const isNarrowScreen = window.innerWidth <= 360;
  const countyName = useSelector((state) => state.countyConfigCommonReducer.countyName);
  const appTitle = useSelector((state) => state.countyConfigCommonReducer.appTitle);

  const [email, setEmail] = React.useState("");
  const [loadingStatus, setLoadingStatus] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [redirectToLogin, setRedirectToLogin] = React.useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    setLoadingStatus(LOADING_STATUES.LOADING);

    axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/forgotUsername", { email }, { withCredentials: true })
      .then((response) => {
        setLoadingStatus("");
        setRedirectToLogin(true);
        setShowAlert(true);
        setAlertMessage(response.data.message);
      }, (error) => {
        setLoadingStatus("");
        setRedirectToLogin(false);
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      });
  };

  const hideAlert = () => {
    setShowAlert(false);
    setAlertMessage("");
    if (redirectToLogin) {
      history.push("/loginMobile");
    }
  };

  return (
    <div>
      {/* Banner */}
      <div style={styles.banner}>
        <div style={styles.logoContainer}>
          <BackButton onClick={() => history.push("/loginHelpMobile")} ariaLabel="Back to login help" />
        </div>

        <div style={styles.titleContainer}>
          <div
            style={{
              ...styles.title,
              fontSize: isNarrowScreen ? "16px" : "20px",
            }}
          >
            {countyName}
          </div>
          <div
            style={{
              ...styles.subtitle,
              fontSize: isNarrowScreen ? "13px" : "16px",
            }}
          >
            {appTitle}
          </div>
        </div>

        <div style={styles.right} />
      </div>

      {/* Content */}
      <div style={styles.content}>
        <h2
          style={{
            ...styles.pageTitle,
            fontSize: isNarrowScreen ? "18px" : "20px",
          }}
        >
          Forgot Username?
        </h2>

        <div style={styles.hint}>Enter your email below. If it matches a registered user, we'll email you your username.</div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div>
            <label style={styles.label} htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              style={styles.input}
            />
          </div>

          <button type="submit" disabled={loadingStatus === LOADING_STATUES.LOADING} style={styles.submitButton}>
            {loadingStatus === LOADING_STATUES.LOADING ? "Sending..." : "Send Email"}
          </button>
        </form>
      </div>

      <Loading loadingIndicator={loadingStatus === LOADING_STATUES.LOADING} />
      <Alert show={showAlert} hideAlert={hideAlert} message={alertMessage} />
    </div>
  );
}

const styles = {
  banner: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    alignItems: "center",
    backgroundColor: "#114E6B",
    color: "white",
    padding: "14px 16px",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    boxSizing: "border-box",
    overflowX: "hidden",
    zIndex: 1000,
  },

  logoContainer: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  titleContainer: {
    marginLeft: "8px",
    textAlign: "left",
  },

  title: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "1.2",
    color: "white",
  },

  subtitle: {
    fontSize: "16px",
    letterSpacing: "0.5px",
    opacity: 0.9,
    color: "white",
  },

  right: {
    justifySelf: "end",
    width: "40px",
  },

  content: {
    marginTop: "70px",
    padding: "16px",
  },

  pageTitle: {
    marginBottom: "8px",
    color: "#114E6B",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  label: {
    display: "block",
    fontSize: "13px",
    fontWeight: "bold",
    color: "#114E6B",
    marginBottom: "4px",
  },

  input: {
    width: "100%",
    padding: "10px",
    fontSize: "16px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  hint: {
    color: "#6c757d",
    fontSize: "12px",
    marginBottom: "16px",
  },

  submitButton: {
    width: "100%",
    marginTop: "8px",
    backgroundColor: "#114E6B",
    color: "white",
    padding: "10px",
    borderRadius: "6px",
    border: "none",
    fontWeight: "bold",
    cursor: "pointer",
  },
};
